import { Routes, Route } from "react-router-dom";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import Awakening from "./components/pages/Awakening";
import Contact from "./components/pages/Contact";
import MentionsLegals from "./components/pages/MentionsLegals";
// import Contact from "./pages/contact";

import "./assets/style/carroussel.css";
import "./assets/style/setup.css";
import "./assets/style/style.css";
import "./assets/style/responsive.css";
import "./assets/style/mentionsLegals.css";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/awakening" element={<Awakening />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/legal" element={<MentionsLegals />} />
      {/* <Route path="/contact" element={<Contact />} /> */}
    </Routes>
  );
}
